/**
 * Resultado de verificar la sesion guardada contra /api/auth/me.
 * - valid: el backend devolvio el usuario.
 * - invalid: la sesion no sirve (401, que es lo que el backend usa para token invalido,
 *   vencido, revocado o usuario inactivo; o no hay token).
 * - transient: no se pudo verificar (5xx, timeout, error de red, 408/429) o el backend
 *   respondio otro 4xx que no invalida la sesion (403 = permisos, 402 = suscripcion).
 *   Los tokens se conservan.
 */
export type VerifyResult = 'valid' | 'invalid' | 'transient';

const TRANSIENT_CODES = new Set(['ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK', 'ECONNRESET', 'ECONNREFUSED']);

export function classifyVerifyError(error: unknown): Exclude<VerifyResult, 'valid'> {
  const e = (error ?? {}) as { response?: { status?: unknown }; code?: unknown; isAxiosError?: unknown; request?: unknown };
  const status = e.response?.status;
  if (status === 401) return 'invalid';
  if (typeof status === 'number') return 'transient';
  if (typeof e.code === 'string' && TRANSIENT_CODES.has(e.code)) return 'transient';
  // Error de axios sin respuesta (red caida, CORS, timeout sin code).
  if (e.isAxiosError === true || e.request !== undefined) return 'transient';
  // api.getCurrentUser convierte el 401 en un Error plano y tambien lanza si no hay token.
  return 'invalid';
}
